import { style } from 'typestyle';
import { COLOR_26, COLOR_35, FONT_WEIGHT_MEDIUM, MARGINS_PX } from '../../../constants';
import { mixinFont } from '../../../style.mixin';

export const quotaTypeNotesClassName = style({
    ...mixinFont(12, FONT_WEIGHT_MEDIUM, 16),
    margin: MARGINS_PX + 'px 0 0 0',
    fontStyle: 'italic'
});

export const quotaTypeNotesThemeBlueClassName = style({
    color: COLOR_26
});

export const quotaTypeNotesThemeGreenClassName = style({
    color: COLOR_35
});
